import "./App.css";
import Footer from "./Components/Home/Footer";
import Message from "./Components/Home/Message";
import Social from "./Components/Home/Social";
import Navbar from "./Components/Navbar";
import AllRoutes from "./Routes/AllRoutes";

function App() {
  return (
    <div className="App">
      <Navbar />
      <AllRoutes />
      <Message />
      <Footer />
      <Social />
    </div>
  );
}

export default App;
